// Remplacer ces valeurs avant mise en ligne.
export const agency = {
  brand: "SIMNON'S SERVICES",
  whatsapp: ' 22892607828', // Indicatif + numéro, sans + ni espaces. Exemple fictif : 22890000000
  phone: ' +228 92 60 78 28', // Numéro de téléphone avec indicatif, exemple fictif : +228 90 00 00 00
  email: 'simnonservices@gmail.com',
  address: 'Lomé, Togo',
  hours: 'Lundi – Samedi · Sur rendez-vous',
};
export const whatsappUrl = (message) => agency.whatsapp
  ? `https://wa.me/${agency.whatsapp.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`
  : null;
